import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import PriceCalculatorPanel from '../../components/calculator/PriceCalculatorPanel';
import Footer from '../../components/front/Footer';
import Header from '../../components/front/Header';
import { publicColors } from '../../components/front/publicTheme';
import './style.css';

function PublicCalculatorPage() {
    return (
        <div className="public-calculator-page">
            <Header />
            <main>
                <Container maxWidth="lg" sx={{ py: 4 }}>
                    <Typography
                        variant="h3"
                        component="h1"
                        gutterBottom
                        sx={{
                            textAlign: 'center',
                            mb: 1,
                            color: publicColors.ink,
                            fontWeight: 800,
                            fontSize: { xs: '1.75rem', md: '2.25rem' },
                        }}
                    >
                        Decida o preço com custo real — não no achismo
                    </Typography>
                    <PriceCalculatorPanel
                        variant="public"
                        intro="Simule multiparte, embalagem, taxa de marketplace e maquininha. Grátis, sem login — para ver o mínimo que precisa cobrar antes de aceitar o pedido."
                    />
                </Container>
            </main>
            <Footer />
        </div>
    );
}

export default PublicCalculatorPage;
